import styled from 'styled-components';
import { colors } from '../../../../theme';

export const StepConfigureContainerStyled = styled.div`
    display: flex;
    gap: 16px;
    height: 70vh;
    padding-top: 16px;
`;

export const StepConfigurePanelStyled = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: ${colors.grey000};
    border-radius: 8px;
    padding: 16px;
    border: 1px solid ${colors.grey500};
    overflow: hidden;
`;

export const StepConfigureActionsStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-shrink: 0;
`;

export const StepConfigureFooterStyled = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
    flex-shrink: 0;
`;
